module.exports = __webpack_public_path__ + "static/japan08-7fbeb3e7382aa099e6e39e30f06df070.jpg";